export default __webpack_public_path__ + "static/media/pope_worldwide_zh.5394bcf9.svg";